<template>
  <div id="zhixin-app">
    <div class="box-active1">
      <Header v-show="headerShow" ref="nav" />
      <Banner />
    </div>
    <el-main>
      <!-- <router-view /> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
    </el-main>
    <!-- <Footer /> -->
    <footer-module></footer-module>
    <Aside />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Header from '@/components/Header.vue'
import Banner from '@/components/Banner/index.vue'
// import Footer from '@/components/Footer.vue'
import Aside from '@/components/Aside.vue'
import Vue from 'vue'
import { FooterModule } from 'lingdongliang-module'
Vue.use(FooterModule)
export default {
  data: function () {
    return {
      headerShow: true,
      banner: true,
      i: 0,
      show: true
    }
  },
  mounted () {
    this.getUserInfo()
    // 监听（绑定）滚轮 滚动事件
    window.addEventListener('scroll', this.handleScroll, true)
  },
  components: {
    Header,
    // Footer,
    Aside,
    Banner,
    'footer-module': FooterModule
  },
  computed: {
    key () {
      return this.$route.path + Math.random()
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    handleScroll () {
      // 页面滚动距顶部距离
      const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scroll === 0) {
        this.headerShow = true
      } else if (scroll < 0) {
        // this.headerShow = true
        this.banner = true
      } else {
        this.headerShow = false
        this.banner = false
      }
    }
  }
}
</script>
<style lang="scss">
  @import "assets/scss/_base.scss";

  #zhixin-app {
    width: 100%;
    font-family: $family;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: $base-color;
    background: $body-bg;

    main {
      margin-top: 79px;
      min-height: 80vh;
      padding: 0;
    }

    .box-active {
      position: relative;
    }

    .box-active1 {
      width: 100%;
      position: fixed;
      top: 0;
      z-index: 103;
    }
  }
</style>
